const tamilnaduDistricts = [
  { label: "Ariyalur", value: "ARIYALUR" },
  { label: "Chengalpattu", value: "CHENGALPATTU" },
  { label: "Chennai", value: "CHENNAI" },
  { label: "Coimbatore", value: "COIMBATORE" },
  { label: "Cuddalore", value: "CUDDALORE" },
  { label: "Dharmapuri", value: "DHARMAPURI" },
  { label: "Dindigul", value: "DINDIGUL" },
  { label: "Erode", value: "ERODE" },
  { label: "Kallakurichi", value: "KALLAKURICHI" },
  { label: "Kancheepuram", value: "KANCHEEPURAM" },
  { label: "Kanyakumari", value: "KANYAKUMARI" },
  { label: "Karapakkam", value: "KARAPAKKAM" },
  { label: "Karur", value: "KARUR" },
  { label: "Krishnagiri", value: "KRISHNAGIRI" },
  { label: "Madurai", value: "MADURAI" },
  { label: "Mayiladuthurai", value: "MAYILADUTHURAI" },
  { label: "Nagapattinam", value: "NAGAPATTINAM" },
  { label: "Namakkal", value: "NAMAKKAL" },
  { label: "Perambalur", value: "PERAMBALUR" },
  { label: "Pudukkottai", value: "PUDUKKOTTAI" },
  { label: "Ranipet", value: "RANIPET" },
  { label: "Ramanathapuram", value: "RAMANATHAPURAM" },
  { label: "Salem", value: "SALEM" },
  { label: "Sivagangai",value:"SIVAGANGAI"},
  { label: "Tenkasi",value:"Tenkasi"},
  { label: "The Nilgiris", value: "THE NILGIRIS" },
  { label: "Thanjavur", value: "THANJAVUR" },
  { label: "Theni", value: "THENI" },
  { label: "Thirupathur", value: "THIRUPPATHUR" },
  { label: "Thiruchirappalli", value: "TIRUCHIRAPPALLI" },
  { label: "Thiruvallur", value: "THIRUVALLUR" },
  { label: "Thiruvannamalai", value: "THIRUVANNAMALAI" },
  { label: "Thiruvarur", value: "THIRUVARUR" },
  { label: "Thoothukudi", value: "THOOTHUKUDI" },
  { label: "Tirunelveli", value: "TIRUNELVELI" },
  { label: "Tuticorin",value:"TUTICORIN"},
  { label: "Tiruppur", value: "TIRUPPUR" },
  {label:"Thenkasi",value:"THENKASI"},
  { label: "Vellore", value: "VELLORE" },
  { label: "Villupuram", value: "VILLUPURAM" },
  { label: "Virudhunagar", value: "VIRUDHUNAGAR" },
  { label: "Others", value: "OTHERS" },
  
];

export default tamilnaduDistricts;
